import { BadRequestError } from '@cian/valuation-utils-component';

import {
  IMappers,
  IGetFiltersWebRequest,
} from '../../../repositories/price-estimator/v3/get-filters-web';
import {IFilterResponseV3} from "../../../repositories/price-estimator/entities/filter/FilterResponseV3";

export const createMapper = (parameters: IGetFiltersWebRequest): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response,
  400: ({ message, errors }) =>
    new BadRequestError({
      message: message as string,
      domain: 'getPreciseFilters.ts',
      details: { errors: JSON.stringify(errors), parameters: JSON.stringify(parameters) },
    }),
});

export type TMappedResponse200 = IFilterResponseV3;
export type TMappedResponse400 = BadRequestError;

export type TPreciseFiltersResponseMapped = TMappedResponse200 | TMappedResponse400;
